import { GetExtension } from "./GetExtension";

export function ValidExtension(fileName, excelOnly, customType, restrictArray) {
  var ext = GetExtension(fileName);
  var valid = false;

  if (restrictArray && restrictArray.length > 0 && restrictArray.indexOf(ext) < 0) return valid;

  if (customType != null) {
    return ext == customType;
  }

  if (excelOnly) {
    switch (ext) {
      case "xlsx":
      case "xls":
        valid = true;
        break;
    }

    return valid;
  }
  //TODO: Surely there is an easier way to do this
  switch (ext) {
    case "json":
    case "xlsx":
    case "xls":
    case "jpeg":
    case "png":
    case "jpg":
    case "oc5":
    case "ocd":
    case "ocb":
    case "oc5m":
    case "oc5p":
    case "svg":
    case "pdf":
    case "ppt":
    case "pptx":
    case "csv":
    case "txt":
    case "zip":
    case "xml":
    case "oc5c":
    case "enc":
    case "pgp":
      valid = true;
      break;
  }

  return valid;
}
